/* TinyOops advertorial mobile layout v2 (5.9.2026)
   Below 1024px the top bundle card is moved out of the page, the story comes first and the offer card at the end.
   A slim sticky bar keeps the CTA one tap away. Re-evaluated on resize/rotation. */
(function () {
  'use strict';
  function ready(fn) { document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn(); }
  ready(function () {
    var adv = document.querySelector('.adv');
    if (!adv) return;
    var grid = adv.querySelector('section .grid');
    var side = grid ? grid.children[1] : null;
    var holder = document.createElement('div');
    var mq = window.matchMedia('(max-width: 1023.98px)');
    var css = document.createElement('style');
    css.textContent =
      '.to-advbar{display:none;position:sticky;top:0;z-index:40;align-items:center;justify-content:space-between;gap:12px;padding:10px 16px;background:#F7F4EE;border-bottom:2px solid #26241F}' +
      '.to-advbar.on{display:flex}' +
      '.to-advbar b{font:800 14px/1.2 "Bricolage Grotesque",sans-serif;color:#26241F}' +
      '.to-advbar small{display:block;font:500 11.5px/1.2 Quicksand,sans-serif;color:rgba(38,36,31,.7);margin-top:2px}' +
      '.to-advbar a{flex:none;display:inline-flex;align-items:center;min-height:40px;padding:0 14px;background:#A8AD4D;color:#26241F;border:2px solid #26241F;border-radius:999px;box-shadow:3px 3px 0 #26241F;font:800 13px/1 "Bricolage Grotesque",sans-serif;text-decoration:none;white-space:nowrap}';
    document.head.appendChild(css);
    var bar = document.createElement('div');
    bar.className = 'to-advbar';
    bar.innerHTML = '<div><b>TinyOops mat \u00b7 from $34.90</b><small>Buy 3, get 3 free \u00b7 90-day guarantee</small></div><a href="/products/tinyoops-washable-mat#buy">Check availability</a>';
    adv.insertBefore(bar, adv.firstChild);
    function apply() {
      var mobile = mq.matches;
      bar.classList.toggle('on', mobile);
      if (!side || !grid) return;
      if (mobile) { if (side.parentNode === grid) holder.appendChild(side); }
      else { if (side.parentNode !== grid) grid.appendChild(side); }
    }
    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply); else mq.addListener(apply);
  });
})();
